module.exports = __webpack_public_path__ + "static/images/thermometer.cd1094c62e68af50300cfc4ae537172a.svg";